import React from "react";

import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import { useSelector } from "react-redux";

import { global } from "../context/global";
import FeedbackForm from "./Feedback/FeedbackForm";

export default function FeedbackDialog({ open, onClose }) {
    const auth = useSelector((state) => state.auth);

    if (!auth.account) {
        return null;
    }

    return (
        <Dialog open={open} onClose={onClose} maxWidth={"md"}>
            <DialogTitle>{global.feedback}</DialogTitle>
            <DialogContent>
                <FeedbackForm />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{global.close}</Button>
            </DialogActions>
        </Dialog>
    );
}

